// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import KycVersion from "../../models/kyc-version.model";

class KycVersionService {
  private dispatch = useDispatch();

  public async getDocumentVersionsData(
    accountId: string | undefined
  ): Promise<KycVersion | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: KycVersion;
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/account/${accountId}/versions`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/document-versions/${accountId}`);
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default KycVersionService;
